import { createRef, useEffect, useState, RefObject } from 'react'
import throttle from 'utils/throttle'
/**
 * Check when a ref is in the viewport
 * @param {number} offset - Number of pixels up to the observable element from the top
 */
const useVisibility = (offset = 0): [Boolean, RefObject<any>] => {
  const el = createRef<Element>()
  const [isVisible, setIsVisible] = useState(false)

  const detectVisibility = throttle(() => {
    if (!el.current) {
      return setIsVisible(false)
    }
    const top = el.current.getBoundingClientRect().top
    setIsVisible(top + offset >= 0 && top - offset <= window.innerHeight)
  }, 100)

  useEffect(() => {
    detectVisibility()
    window.addEventListener('scroll', detectVisibility)
    return () => window.removeEventListener('scroll', detectVisibility)
  })

  return [isVisible, el]
}

export default useVisibility
